import { render } from "./ExportPanel.vue?vue&type=template&id=8c502c8a&scoped=true&ts=true"
import script from "./ExportPanel.vue?vue&type=script&lang=ts"
export * from "./ExportPanel.vue?vue&type=script&lang=ts"

import "./ExportPanel.vue?vue&type=style&index=0&id=8c502c8a&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c502c8a"]])

export default __exports__